import { UrlBuilder } from "../js/UrlBuilder.js";
import { URI } from "../config/autodesk.config.js"

export function getToken(payload) {
  const url = new UrlBuilder(URI)
      .set_pathname('/authentication/v2/token')
      .as_href();
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
  }
  const body = Object.keys(payload).map(key => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key])
  }).join('&');

  return fetch(url, { method: 'POST', headers, body })
      .then(r => r.json())
      .then(r => {
        if ('access_token' in r) {
          return r.access_token;
        } else {
          throw new Error(`access_token not contained within auth response: ${JSON.stringify(r)}`);
        }
      });
}